export const OPTION_FILTER_STYLE = {
  true: {
    button: 'bg-blue-light text-white'
  },
  false: {
    button: 'text-grey-dark'
  },
};

export const FILTER = {
  BOOKING: {
    id: 'BOOKING',
    name: 'Booking'
  },
  INVOICE: {
    id: 'INVOICE',
    name: 'Invoice'
  },
  REFUND: {
    id: 'REFUND',
    name: 'Refund'
  }
};

export const FILTER_KEYS = Object.keys(FILTER);

export const TOTAL_OPTION_FITLER = FILTER_KEYS.length;

export const SUBSCRIPTION_STATUS = [
  // 'CREATED',
  'ACTIVE',
  'INACTIVE',
  // 'EXPIRED',
  // 'CONFIRMED',
  // 'PAID'
]